/* eslint-disable */
import { Check, Crop } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
	generateCheckedProps,
	generateDisabledProps,
	generateImageEditButton,
	generateImageUploadButton,
	generateImageUrl,
	generateRandomKey,
	generateRequiredProps,
	getUnitOnProductPageFromFields,
	inputHelper,
	isEmpty,
	objectContainsProperty,
	// options,
} from '../../../Helpers';
import { DropDownIconInput, IconInput } from '../Inputs';
import styles from './ProductDetails.module.scss';
import { ImageCropModal } from '../../Modals/ImageCropModal';
import { VariantCheckboxes } from '../Inputs/VariantCheckboxes';
import { useAuth } from '../../Auth/Login/auth';
import { brandActions, modalActions } from '@/Actions';
import DragDropImage from '@/Components/DragDropImage/dragDropImage';
import FormSectionHeader from '../FormSectionHeader';
import labelGeneratorServices from '@/Services/labelGeneratorServices';
import countableUnitSubTypeServices from '@/Services/countableUnitSubTypeServices';
import { Slider, InputNumber } from 'rsuite';

// const getDensityText = (unitsArr) => {
// const unit = unitsArr?.reduce((finalUnit, currUnit) => {
// if (currUnit?.isApplied) {
// return currUnit?.id;
// }
// return finalUnit;
// }, '');
// if (unit === 'litre') return 'per Litre';
// if (unit === 'floz') return 'per Fl oz';
// return '';
// };

// const perUnitOptions = {
// floz: 'gallon',
// // gallon: ['floz', 'gallon'],
// litre: 'litre',
// };

const ProductDetails = (props) => {
	const { appConfig = {} } = useAuth();
	const { measurement } = appConfig?.configs ?? {};
	const {
		mandatoryFields,
		fields,
		errors,
		handleInput,
		brands,
		generateDefaultOption,
		isDisabled,
		exclude,
		disableUnit,
		subCategoriesList,
		disableMsg,
		disablebox = false,
		handleImageSelect,
		handleUnitChange = () => { },
		handleSubUnitChange = () => { },
		isUnitChange = false,
	} = props;

	const [previousInventoryUnit, setPreviousInventoryUnit] = useState(null);
	const [isInventoryChange, setIsInventoryChange] = useState(false);
	const [machineLabels, setMachineLabels] = useState([]);
	const [subUnitOptions, setSubUnitOptions] = useState([]);

	useEffect(() => {
		props.fetchBrands({
			id: '',
			allData: true,
		});
	}, []);

	useEffect(() => {
		let cancelled = false;
		(async () => {
			try {
				const response = await labelGeneratorServices.getLabels();
				if (cancelled) return;
				if (response?.statusCode === 200) {
					const labels = (response?.savedLabels ?? [])
						.filter((l) => (l?.labelType ?? '').toUpperCase().startsWith('MACHINE'))
						.map((l) => ({
							id: l?.id,
							name: l?.labelName,
							type: l?.labelType,
						}));
					setMachineLabels(labels);
				}
			} catch (e) {
				// silent — dropdown stays empty if labels can't be fetched
			}
		})();
		return () => { cancelled = true; };
	}, []);

	useEffect(() => {
		let cancelled = false;
		(async () => {
			try {
				const response = await countableUnitSubTypeServices.getSubUnits();
				if (cancelled) return;
				if (response?.statusCode === 200) {
					setSubUnitOptions(response?.data ?? []);
				}
			} catch (e) {
				// silent — selector stays hidden if the list can't be fetched
			}
		})();
		return () => { cancelled = true; };
	}, []);

	// Sub-unit is a single, optional selection rendered like the inventory unit.
	const handleSubUnitInput = (e) => {
		const idx = Number(e?.target?.dataset?.id);
		const isChecked = e?.target?.checked;
		const option = subUnitOptions?.[idx];
		if (!option) return;
		handleSubUnitChange(isChecked ? option.id : null);
	};

	const readOnly = () => {
		return fields.productType === 'COMBO';
	};
	const activeSkuType = fields.productClass?.find((ele) => {
		return ele?.isApplied;
	});
	const activeProductUnit = fields.productUnits?.find((ele) => {
		return ele?.isApplied;
	});

	useEffect(() => {
		if (activeProductUnit?.id !== previousInventoryUnit?.id && !isUnitChange) {
			setPreviousInventoryUnit(activeProductUnit);
			setIsInventoryChange(true);

			// Update sales and purchase units when inventory unit changes
			if (activeProductUnit) {
				const updatedSalesUnit = {
					feildName: 'salesUnit',
					modifiedItems: fields.salesUnit?.map(unit => ({
						...unit,
						isApplied: false
					}))
				};

				const updatedPurchaseUnits = {
					feildName: 'purchaseUnits',
					modifiedItems: fields.purchaseUnits?.map(unit => ({
						...unit,
						isApplied: false,
					}))
				};

				handleUnitChange(updatedSalesUnit);
				handleUnitChange(updatedPurchaseUnits);
			}
		}
	}, [activeProductUnit?.id]);

	useEffect(() => {
		if (activeProductUnit?.id === previousInventoryUnit?.id && !isUnitChange) {
			setIsInventoryChange(false);
		}
	}, [fields.salesUnit, fields.purchaseUnits]);

	return (
		<div className={`flex items-start gap-4 w-full ${isDisabled ? 'pointer-events-none' : ''}`}>
			<div className='flex items-top gap-2 m-[1rem] w-[20%]'>
				{fields.image ? (
					<div className='flex flex-col gap-2 w-full'>
						<div className='w-full h-52'>
							<img src={fields.image} alt='image' />
						</div>
						{!isDisabled && (
							<>
								<label htmlFor='imageEdit' className='px-4 py-2 bg-blue-400 text-white text-center  rounded-md cursor-pointer hover:bg-primary/90'>Choose An Image</label>
								<input
									type='file'
									id='imageEdit'
									className='hidden'
									accept='image/png, image/jpg, image/jpeg, image/webp'
									name='image'
									onChange={handleImageSelect}
									style={{
										opacity: 0,
										width: 1,
										height: 1,
									}}
								/>
							</>
						)}
					</div>
				) : (
					<div className='w-full h-52'>
						<DragDropImage
							name='image'
							handleImageUpload={handleImageSelect}
						/>
					</div>
				)}
			</div>
			<div className='w-[40%]'>
				<FormSectionHeader
					tooltip='description for the section'
					sectionName='Product Details'
				>
					{/* product name */}
					{!objectContainsProperty(exclude, 'name') && (
						<div className='form-field row'>
							<label
								className='form-label'
								htmlFor='productName'
								data-mandatory={mandatoryFields.name}
							>
								Product Name
							</label>
							<input
								className='form-value'
								type='text'
								id='productName'
								name='name'
								onInput={handleInput}
								value={fields.name}
								{...generateRequiredProps(mandatoryFields.name)}
							/>
							<span className='form-error'>{errors.name}</span>
						</div>
					)}
					{/* description */}
					{!objectContainsProperty(exclude, 'description') && (
						<div className='form-field row'>
							<label
								className='form-label'
								htmlFor='description'
								data-mandatory={mandatoryFields.description}
							>
								Description
							</label>
							<textarea
								className='form-value'
								type='text'
								id='description'
								name='description'
								onInput={handleInput}
								value={fields.description}
								{...generateRequiredProps(
									mandatoryFields.description
								)}
							/>
							<span className='form-error'>
								{errors.description}
							</span>
						</div>
					)}
					{/* brand name */}
					{!objectContainsProperty(exclude, 'brand') && (
						<div className='form-field row'>
							<label
								className='form-label'
								htmlFor='brand'
								data-mandatory={mandatoryFields.brand}
							>
								Brand
							</label>
							<select
								className='form-value'
								id='brand'
								name='brand'
								onChange={handleInput}
								value={fields.brand}
								{...generateRequiredProps(
									mandatoryFields.brand
								)}
							>
								{generateDefaultOption(
									'brand',
									fields.brand,
									fields.category
								)}
								{Object.keys(brands).map((brandId) => {
									const brand = brands[brandId];
									return (
										<option value={brandId}>
											{brand.name}
										</option>
									);
								})}
								{/* <option value='1'>Default</option> */}
							</select>
							<span className='form-error'>{errors.brand}</span>
						</div>
					)}
					{/* category name */}
					{!objectContainsProperty(exclude, 'category') && (
						<div className='form-field row'>
							<label
								className='form-label'
								htmlFor='category'
								data-mandatory={mandatoryFields.category}
							>
								Category
							</label>
							<select
								className='form-value'
								id='category'
								name='category'
								onChange={handleInput}
								disabled={!fields.brand}
								value={fields.category}
								{...generateRequiredProps(
									mandatoryFields.category
								)}
							>
								{generateDefaultOption(
									'category',
									fields.brand,
									fields.category
								)}
								{fields.brand &&
									!isEmpty(brands) &&
									Object.keys(
										brands[fields.brand]?.ProductCategory || {}
									)
										?.filter((categoryId) => {
											const category =
												brands[fields.brand]
													.ProductCategory[
												categoryId
												];
											return !category?.isDeleted;
										})
										.map((categoryId) => {
											const category =
												brands[fields.brand]
													.ProductCategory[
												categoryId
												];
											return (
												<option value={categoryId}>
													{
														category.productCategoryName
													}
												</option>
											);
										})}
							</select>
							<span className='form-error'>
								{errors.category}
							</span>
						</div>
					)}
					{/* subcategory name */}
					{!objectContainsProperty(exclude, 'subcategory') && (
						<div className='form-field row'>
							<label
								className='form-label'
								htmlFor='subcategory'
								data-mandatory={mandatoryFields.subCategory}
							>
								Sub Category
							</label>
							<select
								className='form-value'
								id='subcategory'
								name='subCategory'
								onChange={handleInput}
								// disabled={!fields.subCategory}
								value={fields.subCategory ?? ''}
								{...generateRequiredProps(
									mandatoryFields.subCategory
								)}
							>
								{generateDefaultOption(
									'subCategory',
									fields.brand,
									fields.category,
									fields.subCategory
								)}
								{subCategoriesList?.map((subCat) => {
									return (
										<option value={subCat?.id}>
											{subCat?.name}
										</option>
									);
								})}
							</select>
							<span className='form-error'>
								{errors.subcategory}
							</span>
						</div>
					)}
					{/* price and tax */}
					{!objectContainsProperty(exclude, 'tax') && (
						<div className='form-field row'>
							<label
								className='form-label'
								htmlFor='tax'
								style={{
									width: 'auto',
									minWidth: 'auto',
								}}
								{...generateRequiredProps(mandatoryFields.tax)}
							>
								Tax
							</label>
							<IconInput
								size='large'
								type='percent'
								name='tax'
								style={{
									position: 'relative',
									left: '11rem',
								}}
								id='tax'
								step='any'
								value={fields.tax}
								handleInput={handleInput}
								dataType=''
								dataId=''
								{...generateRequiredProps(mandatoryFields.tax)}
								dataAttrs={{
									min: 0,
									required: mandatoryFields.tax,
									max: 100,
									disabled: readOnly(),
								}}
							/>
						</div>
					)}
					{/*  HSN Code */}
					{!objectContainsProperty(exclude, 'hsnCode') && (
						<div className='form-field row'>
							<label
								className='form-label'
								htmlFor='hsnCode'
								data-mandatory={mandatoryFields.hsnCode}
							>
								HSN Code
							</label>
							<input
								className='form-value'
								type='text'
								id='hsnCode'
								name='hsnCode'
								onInput={handleInput}
								value={fields.hsnCode}
								{...generateRequiredProps(mandatoryFields.hsnCode)}
							/>
							<span className='form-error'>{errors.hsnCode}</span>
						</div>
					)}
					{/* Product Price Fixed */}
					{!objectContainsProperty(exclude, 'priceFixed') && (
						<div className='form-field row'>
							<label
								className='form-label'
								htmlFor='priceFixed'
							>
								Product Price Fixed
							</label>
							<input
								type='checkbox'
								id='priceFixed'
								name='priceFixed'
								checked={!!fields.priceFixed}
								onChange={handleInput}
								disabled={isDisabled}
							/>
						</div>
					)}
					{/* Traded (only applicable to Product type) */}
					{!objectContainsProperty(exclude, 'traded') && activeSkuType?.name === 'Product' && (
						<div className='form-field row'>
							<label
								className='form-label'
								htmlFor='traded'
							>
								White Labelled/Traded
							</label>
							<input
								type='checkbox'
								id='traded'
								name='traded'
								checked={!!fields.traded}
								onChange={handleInput}
								disabled={isDisabled}
							/>
						</div>
					)}
					{!objectContainsProperty(exclude, 'freshlyPrepared') && ['Product'].includes(activeSkuType?.name) && (
						<div className='form-field row'>
							<label
								className='form-label'
								htmlFor='freshlyPrepared'
								title='If checked, the outlet manages this product stock directly. If unchecked, its recipe is used for inventory deduction.'
							>
								Assembled At Outlet
							</label>
							<input
								type='checkbox'
								id='freshlyPrepared'
								name='freshlyPrepared'
								checked={!!fields.freshlyPrepared}
								onChange={handleInput}
								disabled={isDisabled}
								title='If checked, the outlet manages this product stock directly. If unchecked, its recipe is used for inventory deduction.'
							/>
						</div>
					)}
					{/* Freshly Procured (Ingredient only) — auto-creates the GRN batch (qty = PO qty,
					mfg date = today, expiry = today + Expires In) instead of manual batch entry */}
					{!objectContainsProperty(exclude, 'freshlyProcured') && activeSkuType?.id === 'ingredient' && (
						<div className='form-field row'>
							<label
								className='form-label'
								htmlFor='freshlyProcured'
								title='If checked, GRN batches for this ingredient are created automatically using the PO quantity, mfg date = today, and expiry from Expires In — no manual batch entry needed.'
							>
								Freshly Procured
							</label>
							<input
								type='checkbox'
								id='freshlyProcured'
								name='freshlyProcured'
								checked={!!fields.freshlyProcured}
								onChange={handleInput}
								disabled={isDisabled}
								title='If checked, GRN batches for this ingredient are created automatically using the PO quantity, mfg date = today, and expiry from Expires In — no manual batch entry needed.'
							/>
						</div>
					)}
					{!objectContainsProperty(exclude, 'skipPrimaryPackaging') && (
						<div className='form-field row'>
							<label
								className='form-label'
								htmlFor='skipPrimaryPackaging'
							>
								Skip Primary Packaging
							</label>
							<input
								type='checkbox'
								id='skipPrimaryPackaging'
								name='skipPrimaryPackaging'
								checked={!!fields.skipPrimaryPackaging}
								onChange={handleInput}
								disabled={isDisabled}
							/>
						</div>
					)}
					{/* Labelled In Bulk (Product only) — the production plan's labelling work order for it is not run */}
					{!objectContainsProperty(exclude, 'labelledInBulk') && activeSkuType?.name === 'Product' && (
						<div className='form-field row'>
							<label
								className='form-label'
								htmlFor='labelledInBulk'
								title='If checked, this product is labelled in bulk, so the production plan does not create an active labelling work order for it.'
							>
								Labelled In Bulk
							</label>
							<input
								type='checkbox'
								id='labelledInBulk'
								name='labelledInBulk'
								checked={!!fields.labelledInBulk}
								onChange={handleInput}
								disabled={isDisabled}
								title='If checked, this product is labelled in bulk, so the production plan does not create an active labelling work order for it.'
							/>
						</div>
					)}
					{/* Default Print Label (optional) */}
					{!objectContainsProperty(exclude, 'defaultLabelId') && (
						<div className='form-field row'>
							<label
								className='form-label'
								htmlFor='defaultLabelId'
							>
								Default Print Label
							</label>
							<select
								className='form-value'
								id='defaultLabelId'
								name='defaultLabelId'
								onChange={handleInput}
								value={fields.defaultLabelId ?? ''}
							>
								<option value=''>None</option>
								{machineLabels.map((l) => (
									<option key={l.id} value={l.id}>
										{l.name}
									</option>
								))}
							</select>
						</div>
					)}
					{/* product Code */}
					{!objectContainsProperty(exclude, 'productCode') && (
						<div className='form-field row'>
							<label
								className='form-label'
								htmlFor='productCode'
								data-mandatory={mandatoryFields.productCode}
							>
								Product Code
							</label>
							<input
								className='form-value'
								type='text'
								id='productCode'
								name='productCode'
								onInput={handleInput}
								value={fields.productCode}
								{...generateRequiredProps(mandatoryFields.productCode)}
							/>
							<span className='form-error'>{errors.productCode}</span>
						</div>
					)}
					{/* expiry */}
					{!objectContainsProperty(exclude, 'expiry') && (
						<>
							<div className='form-field row'>
								<label
									className='form-label'
									htmlFor='expires'
									data-mandatory={mandatoryFields.expiry}
								>
									Expires In
								</label>
								<DropDownIconInput
									size='large'
									type='custom'
									name='expiry'
									id='expiry'
									dataType=''
									dataId=''
									value={fields.expiry}
									handleInput={handleInput}
									selectValue={fields.expiryUnit}
									dataAttrs={{
										required: mandatoryFields.expiry,
									}}
								/>
							</div>
							{fields?.expiryUnit?.toLowerCase() === 'days' && <span className='text-[12px] text-orange-400'>expiry date is calculated excluding the manufacturing date</span>}
						</>
					)}
					{/* expiry Secondary*/}
					{!objectContainsProperty(exclude, 'expirySecondary') && (
						<>
							<div className='form-field row'>
								<label
									className='form-label'
									htmlFor='expiresSecondary'
								>
									Secondary Expires In
								</label>
								<DropDownIconInput
									size='large'
									type='custom'
									name='expirySecondary'
									id='expirySecondary'
									dataType=''
									dataId=''
									value={fields.expirySecondary}
									handleInput={handleInput}
									selectValue={fields.expirySecondaryUnit}
									dataAttrs={{
										required: mandatoryFields.expirySecondary,
									}}
								/>
							</div>
							{fields?.expirySecondaryUnit?.toLowerCase() === 'days' && <span className='text-[12px] text-orange-400'>expiry date is calculated excluding the thawing date</span>}
						</>
					)}
				</FormSectionHeader>
			</div>
			<div className='w-[40%]'>
				<FormSectionHeader
					tooltip='description for the section'
					sectionName='Product Unit configuration'
				>
					{/* purchase unit */}
					<div className='relative w-full'>
						{/* Overlay for disable message */}
						{disableMsg && (
							<div className='w-full h-full absolute top-[-6px] left-0 flex items-center justify-center bg-white bg-opacity-50 cursor-not-allowed z-10'>
								<p className='text-red-800 text-xl text-center font-bold relative left-0'>{disableMsg}</p>
							</div>
						)}

						{/* Product Unit */}
						{!objectContainsProperty(exclude, 'productUnits') && (
							<div className='form-field row mt-12 relative'>
								<label className='form-label' data-mandatory={mandatoryFields.productUnit}>
									Inventory Unit
								</label>
								<VariantCheckboxes
									items={fields?.productUnits ?? []}
									fieldName='productUnits'
									handleInput={handleInput}
									errorMessage={disableUnit ? 'Unit picked from product Category' : ''}
									isDisabled={disablebox ? true : disableUnit}
								/>
								<span className='form-error'>{errors.name}</span>
							</div>
						)}
						{/* Sub Unit — only when inventory unit is count and the customer has a configured list */}
						{!objectContainsProperty(exclude, 'subUnit') && activeProductUnit?.id === 'count' && subUnitOptions.length > 0 && (
							<div className='form-field row mt-12 relative'>
								<label className='form-label'>
									Sub Unit
								</label>
								<VariantCheckboxes
									items={subUnitOptions.map((option) => ({
										id: option.id,
										name: option.name,
										isApplied: option.id === fields?.subUnitId,
									}))}
									fieldName='subUnit'
									handleInput={handleSubUnitInput}
									isDisabled={isDisabled}
								/>
							</div>
						)}
						{/* Sales/Consumption Unit */}
						{!objectContainsProperty(exclude, 'salesUnit') && getUnitOnProductPageFromFields({ fields }, 'productUnits') == 'count' && (
							<div className='form-field row mt-12 relative'>
								<label className='form-label' data-mandatory={mandatoryFields.salesUnit}>
									Sales/Consumption Unit
								</label>
								<VariantCheckboxes
									items={fields?.salesUnit ?? []}
									fieldName='salesUnit'
									handleInput={handleInput}
									isDisabled={isDisabled}
									inventoryUnit={fields?.productUnits?.find((ele) => ele?.isApplied)}
									isInventoryChange={isInventoryChange}
									handleUnitChange={handleUnitChange}
								/>
								<span className='form-error'>{errors.name}</span>
							</div>
						)}
						{/* Purchase Unit */}
						{!objectContainsProperty(exclude, 'purchaseUnits') && !['Product', 'Intermediate'].includes(activeSkuType?.name) && (
							<div className='form-field row mt-12 relative'>
								<label className='form-label' data-mandatory={mandatoryFields.purchaseUnits}>
									Purchase Unit
								</label>
								<VariantCheckboxes
									items={fields?.purchaseUnits ?? []}
									fieldName='purchaseUnits'
									handleInput={handleInput}
									isDisabled={disablebox ? true : isDisabled}
									inventoryUnit={fields?.productUnits?.find((ele) => ele?.isApplied)}
									isInventoryChange={isInventoryChange}
									handleUnitChange={handleUnitChange}
								/>
								<span className='form-error'>{errors.name}</span>
							</div>
						)}
					</div>

					{/* product Density */}
					{!objectContainsProperty(exclude, 'density') && activeProductUnit?.id === 'ml' && (
						<div
							className='form-field row'
							style={{
								marginTop: '3rem',
							}}
						>
							<label
								className='form-label'
								data-mandatory={mandatoryFields.density}
							>
								Product Density
							</label>
							<div className='flex items-center gap-1'>
								<input
									className='border border-gray-400 rounded-sm h-[30px] w-[120px]'
									type='number'
									id='density'
									name='density'
									onInput={handleInput}
									value={fields.density}
								/>
								<p>
									{fields?.densityUnit} per {fields?.perUnit}
								</p>
							</div>
							<span className='form-error'>{errors.name}</span>
						</div>
					)}
					{/* Per Piece Weight - optional, weight-based items only */}
					{!objectContainsProperty(exclude, 'perPieceWeight') && ['gram', 'oz'].includes(activeProductUnit?.id) && (
						<div className='form-field row'>
							<label className='form-label' htmlFor='perPieceWeight'>
								Per Piece Weight
							</label>
							<div className='flex items-center gap-1'>
								<input
									className='border border-gray-400 rounded-sm h-[30px] w-[120px]'
									type='number'
									min='0'
									step='any'
									id='perPieceWeight'
									name='perPieceWeight'
									onInput={handleInput}
									value={fields.perPieceWeight ?? ''}
									disabled={isDisabled}
								/>
								<p>{activeProductUnit?.id === 'oz' ? 'oz' : 'g'} per piece</p>
							</div>
						</div>
					)}
					{/* veg - nonveg */}
					{!objectContainsProperty(exclude, 'veg') && (
						<div className='form-field row'>
							<label
								htmlFor='customization'
								className='form-label'
								data-mandatory={mandatoryFields.veg}
							>
								Veg
							</label>
							<div className='row'>
								<label
									className={`dot-container veg ${fields.veg ? 'selected' : ''
										} ${isDisabled ? 'disabled' : ''}`}
									htmlFor='veg'
									style={{
										marginRight: '1rem',
									}}
								>
									<div className='dot' />
									<Check className='tick' />
								</label>
								<input
									{...generateRandomKey()}
									type='radio'
									id='veg'
									hidden
									name='veg'
									value={1}
									onChange={handleInput}
									{...generateCheckedProps(fields.veg)}
								/>
								<label
									className={`dot-container non-veg ${fields.veg ? '' : 'selected'
										} ${isDisabled ? 'disabled' : ''}`}
									htmlFor='non-veg'
								>
									<div className='dot' />
									<Check className='tick' />
								</label>
								<input
									{...generateRandomKey()}
									{...generateCheckedProps(!fields.veg)}
									type='radio'
									id='non-veg'
									hidden
									name='veg'
									value={0}
									onChange={handleInput}
								/>
							</div>
						</div>
					)}
					{/* product type */}
					{!objectContainsProperty(exclude, 'productClass') && (
						<div
							className='form-field row'
							style={{
								marginTop: '2rem',
								marginRight: '2rem',
							}}
						>
							<label
								className='form-label'
								data-mandatory={mandatoryFields.productClass}
							>
								Product Type
							</label>
							<VariantCheckboxes
								items={fields.productClass}
								fieldName='productClass'
								handleInput={handleInput}
								display
							/>
							<span className='form-error'>{errors.name}</span>
						</div>
					)}
					{/* Inward tolerance % — only for Ingredient / Packaging / Other */}
					{!objectContainsProperty(exclude, 'inwardTolerance') && ['ingredient', 'packaging', 'other'].includes(activeSkuType?.id) && (
						<div className='form-field row' style={{ marginRight: '2rem' }}>
							<label className='form-label' htmlFor='inwardTolerance'>
								Inward Tolerance
							</label>
							<div className='form-value' style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%' }}>
								<label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', margin: 0 }}>
									<input
										type='checkbox'
										checked={fields.inwardTolerance === -1}
										onChange={(e) => handleInput({ target: { name: 'inwardTolerance', value: e.target.checked ? -1 : null } })}
										disabled={isDisabled}
									/>
									No limit
								</label>
								{fields.inwardTolerance !== -1 && (
									<div style={{ display: 'flex', alignItems: 'center', gap: '12px', width: '100%' }}>
										<Slider
											progress
											style={{ flex: 1 }}
											className='[&_.rs-slider-progress-bar]:!bg-black [&_.rs-slider-handle]:!bg-black [&_.rs-slider-handle]:!border-black'
											value={Number(fields.inwardTolerance) || 0}
											onChange={(value) => handleInput({ target: { name: 'inwardTolerance', value } })}
											min={0}
											max={100}
											disabled={isDisabled}
										/>
										<InputNumber
											min={0}
											max={100}
											value={fields.inwardTolerance ?? ''}
											placeholder='—'
											onChange={(value) => {
												if (value === '' || value === null || value === undefined) {
													handleInput({ target: { name: 'inwardTolerance', value: null } });
													return;
												}
												let v = Number(value);
												if (Number.isNaN(v)) v = 0;
												v = Math.max(0, Math.min(100, v));
												handleInput({ target: { name: 'inwardTolerance', value: v } });
											}}
											disabled={isDisabled}
											style={{ width: 90 }}
										/>
										<span style={{ fontSize: '13px' }}>%</span>
									</div>
								)}
								{fields.inwardTolerance === -1 ? (
									<span style={{ fontSize: '12px', color: '#6b7280' }}>No limit — inward quantity is not restricted.</span>
								) : (
									fields.inwardTolerance === 0 && (
										<span style={{ fontSize: '12px', color: '#6b7280' }}>No extra quantity allowed</span>
									)
								)}
							</div>
						</div>
					)}
					{/* <div className='form-field row'>
						<label
							className='form-label'
							htmlFor='minTemp'
						>
							Min Temperature (℃)
						</label>
						<IconInput
							size='large'
							type='custom'
							iconText='℃'
							name='minTemp'
							id='minTemp'
							value={fields.minTemp}
							handleInput={handleInput}
							dataAttrs={{
								min: -20,
								max: Math.min(120, fields?.maxTemp),
								'data-type': 'temperature',
							}}
							step='0.1'
						/>
					</div>
					<div className='form-field row'>
						<label
							htmlFor='maxTemp'
							className='form-label'
						>
							Max Temperature (℃)
						</label>
						<div className='flex flex-col gap-2'>
						<IconInput
							size='large'
							type='custom'
							iconText='℃'
							name='maxTemp'
							id='maxTemp'
							value={fields.maxTemp}
							handleInput={handleInput}
							dataAttrs={{
								min: Math.max(-20, fields?.minTemp),
								max: 120,
								'data-type': 'temperature',
							}}
							step='0.1'
						/>
						<span
							className='form-info'
							style={{
								margin: 'auto 0px',
								padding: '0px 1rem',
								fontSize: '12px',
							}}
						>
							(Permissible range for temperature is -20℃ to 120℃)
						</span>
						</div>
					</div> */}
				</FormSectionHeader>
			</div>
		</div>
	);
};

ProductDetails.defaultProps = {
	isDisabled: false,
	mandatoryFields: {},
	errors: {},
	handleInput: () => { },
	handleFileInput: () => { },
	generateDefaultOption: () => { },
	generateRequiredProps: () => {
		return {};
	},
	exclude: {},
	// disableUnit: true,
};

const mapStateToProps = (state) => {
	const { brands } = state.brand;
	return {
		brands,
	};
};

const mapDispatchToProps = {
	fetchBrands: brandActions.fetchBrands,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetails);
